/**
 * 既に登録済のスポットであるか
 * @param {Object} target
 * @param {String} target.name スポット名
 * @param {String} target.address 住所名
 * @param {String} target.coord 座標
 * @param {Array} favoriteData 登録済お気に入りスポットリスト
 * @returns 登録済である
 */
export function hasFavoriteSpot(target, favoriteData) {
  // targetにはspot.nameに地点名が入っているが、同一地点比較はspot.spotNameで行いたいため、地点情報を加工する
  const spot = structuredClone(target)
  spot.spotName = spot.name
  delete spot.name

  // お気に入り地点名は、空文字(未設定時)と「名称なし」は同一の扱いとするため、地点名を加工する。
  const unsetSpotName = '名称なし'
  if (spot.spotName == '') spot.spotName = unsetSpotName

  // 判定処理
  return favoriteData.some((base) => checkDuplicationSpot(spot, base))
}

/**
 * 登録日付の新しい地点順で、重複排除(新しい地点を残す)した一覧を返す
 * @param {Array} favorites お気に入り地点一覧
 * @returns 重複排除後のお気に入り地点一覧
 */
export function favoriteSpotFilterDuplication(favorites) {
  return favorites
    .sort((a, b) => a.id - b.id)
    .filter((el, index, self) => {
      return self.findLastIndex((e) => checkDuplicationSpot(e, el)) === index
    })
}

/**
 * 登録済お気に入り地点一覧から特定地点を取得
 * @param {Object} targetSpot 検索対象地点
 * @param {Array} favorites お気に入り地点一覧
 * @returns {Object|undefined} お気に入り地点
 */
export function getFavoriteSpot(targetSpot, favorites) {
  return favorites.find((spot) => checkDuplicationSpot(spot, targetSpot))
}

/**
 * 2つの地点情報が同一地点かどうか
 * @param {Object} spot1 地点1
 * @param {String} spot1.spotName 地点1の地点名
 * @param {String} spot1.address 地点1の住所
 * @param {String} spot1.coord 地点1の座標
 * @param {Object} spot2 地点2
 * @param {String} spot2.spotName 地点2の地点名
 * @param {String} spot2.address 地点2の住所
 * @param {String} spot2.coord 地点2の座標
 */
function checkDuplicationSpot(spot1, spot2) {
  return (
    spot1.spotName == spot2.spotName &&
    spot1.address == spot2.address &&
    spot1.coord == spot2.coord
  )
}
